import { render, staticRenderFns } from "./ModifyCourse.vue?vue&type=template&id=4222d668&scoped=true"
import script from "./ModifyCourse.vue?vue&type=script&lang=js"
export * from "./ModifyCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../Vue/course_selecttion_v3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4222d668",
  null
  
)

export default component.exports